import { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/auth-provider";
import { axiosInstancePublic } from "../../services/axios-instance";
import { GOOGLE_CALLBACK_URL } from "../../services/endpoints";

function GoogleCallback() {
    const { setSession } = useContext(AuthContext);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const getUserDataViaGoogleAuth = async () => {
            try {
                const response = await axiosInstancePublic.get(
                    GOOGLE_CALLBACK_URL(location.search)
                );
                const data = response.data;

                if (response.data.access_token) {
                    setSession(data.access_token);
                    localStorage.setItem("token", data.access_token);
                    navigate("/");
                }
            } catch (error) {
                console.error(error);
            }
        };

        getUserDataViaGoogleAuth();
    }, [location]);

    return (
        <div>
            <p>Loading...</p>
        </div>
    );
}

export default GoogleCallback;
